import React from 'react';
import { Rocket, CheckCircle } from 'lucide-react';
import ScrollReveal from './ScrollReveal'; // <--- Não esquece de importar!

export default function Hero() {
  return (
    <section className="relative bg-conectiva-navy min-h-screen flex items-center pt-20 overflow-hidden">
        
      {/* Efeito de Fundo (Mantive estático pra não pesar) */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 bg-conectiva-lime opacity-10 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {/* Coluna da Esquerda: Texto Persuasivo */}
          <div className="text-center lg:text-left z-10">
            
            {/* 1. Badge (Aparece rápido: 0.1s) */}
            <ScrollReveal delay={0.1}>
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 text-conectiva-lime text-sm font-semibold mb-6 border border-white/20">
                <span className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-conectiva-lime opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-conectiva-lime"></span>
                </span>
                Matrículas Abertas 2026
              </div>
            </ScrollReveal>
            
            {/* 2. Título (Aparece em 0.3s) */}
            <ScrollReveal delay={0.3}>
              <h1 className="text-4xl md:text-6xl font-extrabold text-white leading-tight mb-6">
                Acelere sua carreira na <span className="text-transparent bg-clip-text bg-gradient-to-r from-conectiva-lime to-green-400">Enfermagem</span>
              </h1>
            </ScrollReveal>
            
            {/* 3. Parágrafo (Aparece em 0.5s) */}
            <ScrollReveal delay={0.5}>
              <p className="text-lg text-gray-300 mb-8 leading-relaxed max-w-lg mx-auto lg:mx-0">
                Metodologia prática, laboratórios de alta tecnologia e estágio garantido. Transforme sua vocação em profissão na escola técnica que mais conecta alunos ao mercado.
              </p>
            </ScrollReveal>
            
            {/* 4. Botões (Aparecem em 0.7s) */}
            <ScrollReveal delay={0.7}>
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <button className="flex items-center justify-center gap-2 bg-conectiva-lime text-conectiva-navy px-8 py-4 rounded-lg font-bold text-lg hover:brightness-110 hover:scale-105 transition duration-300 shadow-[0_0_20px_rgba(204,255,0,0.3)]">
                  QUERO MINHA VAGA
                  <Rocket size={20} />
                </button>
                <button className="flex items-center justify-center gap-2 bg-transparent border border-gray-600 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-white/5 transition">
                  Baixar Grade Curricular
                </button>
              </div>
            </ScrollReveal>

            {/* 5. Ícones de check (Aparecem por último: 0.9s) */}
            <ScrollReveal delay={0.9}>
              <div className="mt-8 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center gap-6 justify-center lg:justify-start text-sm text-gray-400">
                <div className="flex items-center gap-2">
                  <CheckCircle size={16} className="text-conectiva-lime" />
                  <span>Certificado pelo MEC</span>
                </div>
                <div className="flex items-center gap-2">
                  <CheckCircle size={16} className="text-conectiva-lime" />
                  <span>Estágio Garantido</span>
                </div>
              </div>
            </ScrollReveal>
          </div>

          {/* Coluna da Direita: Imagem Real da Aluna */}
          {/* A imagem inteira sobe junto com o texto principal (delay 0.5) */}
          <div className="relative hidden lg:block">
            <ScrollReveal delay={0.5}>
              <div className="relative rounded-2xl overflow-hidden border-4 border-white/10 shadow-2xl transform rotate-2 hover:rotate-0 transition duration-500 group">
                <img 
                  src="https://somosconexaosocial.org/connectiva-img/01.jpg"  
                  alt="Aluna Connectiva em Prática" 
                  className="w-full h-[600px] object-cover object-top hover:scale-105 transition duration-700"
                />
                <div className="absolute inset-0 bg-conectiva-navy/10 group-hover:bg-transparent transition"></div>
              </div>
              
              {/* O Card flutuante já tem animate-bounce, então não precisa de ScrollReveal pra não conflitar animações */}
              <div className="absolute bottom-10 -left-10 bg-white p-4 rounded-xl shadow-xl flex items-center gap-4 animate-bounce duration-[3000ms] z-20">
                <div className="bg-green-100 p-2 rounded-full">
                  <CheckCircle className="text-green-600" size={24} />
                </div>
                <div>
                  <p className="text-xs text-gray-500 font-bold uppercase">Taxa de Empregabilidade</p>
                  <p className="text-xl font-bold text-gray-900">92%</p>
                </div>
              </div>
            </ScrollReveal>
          </div>

        </div>
      </div>
    </section>
  );
}